export default __webpack_public_path__ + "static/media/Kubernetes.fd4d529c.jpg";